
interface SidebarProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

export default function Sidebar({ activeTab, setActiveTab }: SidebarProps) {
  const menuItems = [
    { id: 'overview', label: 'Policy Overview', icon: 'ri-dashboard-line' },
    { id: 'personal', label: 'Personal Information', icon: 'ri-user-line' },
    { id: 'household', label: 'Household Members', icon: 'ri-group-line' },
    { id: 'billing', label: 'Bills & Payments', icon: 'ri-bill-line' },
    { id: 'documents', label: 'Documents', icon: 'ri-file-text-line' },
  ];

  return (
    <aside className="w-64 bg-white shadow-sm border-l border-gray-200 min-h-screen">
      <nav className="p-4">
        <ul className="space-y-2">
          {menuItems.map((item) => (
            <li key={item.id}>
              <button
                onClick={() => setActiveTab(item.id)}
                className={`w-full flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors cursor-pointer ${
                  activeTab === item.id
                    ? 'bg-blue-50 text-blue-700 border-l-2 border-blue-600'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                }`}
              >
                <i className={`${item.icon} mr-3 text-lg`}></i>
                {item.label}
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
}
